import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';

import { AccountCardComponent } from './account-card.component';
import { AdminPermissionService } from '../../services/admin-permission.service';
import { SimpleAdminCheckService } from '../../services/simple-admin-check.service';

@NgModule({
  declarations: [
    AccountCardComponent
  ],
  imports: [
    CommonModule,
    MatIconModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    MatSnackBarModule,
    MatTooltipModule,
    MatInputModule,
    MatFormFieldModule
  ],
  providers: [
    AdminPermissionService,
    SimpleAdminCheckService
  ],
  exports: [
    AccountCardComponent
  ]
})
export class AccountCardModule { }


